var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.processBrand },
    [
      _c("div", { staticClass: "row section" }, [
        _c("div", { staticClass: "col-md-12 mb-2" }, [
          _c("div", { staticClass: "text-center" }, [
            _vm.processBrand != "Priimaplus" &&
            !_vm.hasMembership("priima", "omakotiliitto")
              ? _c("p", [
                  _vm._v(
                    "\n                    Oletko yritysasiakas ja sähkönkäyttösi on 100-1000 MWh vuodessa? Tee silloin Priimaplus sopimus\n                    "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        "aria-label": "Tee Priimaplus sopimus",
                        href: "#",
                        title: "Suurasiakas"
                      }
                    },
                    [_vm._v("tästä")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isPriimaplus()
              ? _c("p", [
                  _vm._v(
                    "Sopimuksen tekeminen on helppoa, mutta jos tarvitset apua tai lisätietoa, jätä yhteydenottopyyntö, niin soitamme sinulle pian!"
                  )
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      (this.contract.Customer &&
        this.contract.Customer.TrustedSource == false &&
        this.contract.Company && this.contract.Company.TrustedSource == false) &
      !_vm.isPriimaplus()
        ? _c("div", { staticClass: "row section" }, [
            _c("div", { staticClass: "col-md-12 mb-2" }, [
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "new-contract-value",
                          rawName: "v-new-contract-value"
                        }
                      ],
                      class: {
                        active:
                          _vm.contract.CustomerType ==
                          _vm.CustomerTypeEnum.CONSUMER
                      },
                      staticStyle: {
                        "min-width": "220px",
                        "margin-bottom": "2px !important"
                      },
                      attrs: {
                        type: "button",
                        variant: "outline-default",
                        value: _vm.CustomerTypeEnum.CONSUMER,
                        name: "customerType"
                      },
                      on: { "value-updated": _vm.customerTypeSelected }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "user" } }),
                      _vm._v(" " + _vm._s(_vm.$t("Henkilöasiakas")) + " ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "new-contract-value",
                          rawName: "v-new-contract-value"
                        }
                      ],
                      class: {
                        active:
                          _vm.contract.CustomerType ==
                          _vm.CustomerTypeEnum.COMPANY
                      },
                      staticStyle: {
                        "min-width": "220px",
                        "margin-bottom": "2px !important"
                      },
                      attrs: {
                        type: "button",
                        variant: "outline-default",
                        value: _vm.CustomerTypeEnum.COMPANY,
                        name: "customerType"
                      },
                      on: { "value-updated": _vm.customerTypeSelected }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "building" } }),
                      _vm._v(" " + _vm._s(_vm.$t("Yritysasiakas")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.showLoadingIndicator
                        ? _c("loading-indicator", {
                            staticClass: "loading-indicator"
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isPriima()
        ? [
            _c(
              "new-contract-section",
              {
                ref: "preProduct",
                attrs: {
                  number: _vm.phaseNumber(1),
                  title: "Kohteen tiedot",
                  mode: _vm.sections.preProduct.mode,
                  "proceed-action-state": _vm.sections.preProduct.proceedActionState()
                },
                on: {
                  modify: function($event) {
                    return _vm.sections.preProduct.enterModify()
                  },
                  proceed: function($event) {
                    return _vm.sections.preProduct.proceed()
                  }
                }
              },
              [
                _c("pre-product-selection", {
                  ref: "preProductSelection",
                  attrs: {
                    slot: "edit",
                    contract: _vm.contract,
                    "validation-errors": _vm.validationErrors
                  },
                  slot: "edit"
                }),
                _vm._v(" "),
                _c("pre-product-selection-display", {
                  attrs: { slot: "display", contract: _vm.contract },
                  slot: "display"
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "new-contract-section",
        {
          ref: "product",
          attrs: {
            number: _vm.phaseNumber(2),
            title: _vm.productSelectionPhaseTitle(),
            mode: _vm.sections.product.mode,
            "proceed-action-state": _vm.sections.product.proceedActionState()
          },
          on: {
            modify: function($event) {
              return _vm.sections.product.enterModify()
            },
            proceed: function($event) {
              return _vm.sections.product.proceed()
            }
          }
        },
        [
          _c("product-selection", {
            attrs: { slot: "edit" },
            on: {
              "product-selected": function($event) {
                return _vm.sections.product.proceed()
              }
            },
            slot: "edit"
          }),
          _vm._v(" "),
          !_vm.offerRequest
            ? _c("product-selection-display", {
                attrs: { slot: "display" },
                slot: "display"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.offerRequest
            ? _c("offer-product-selection-display", {
                attrs: { slot: "display" },
                slot: "display"
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.contract.CustomerType !== _vm.CustomerTypeEnum.COMPANY
        ? _c(
            "new-contract-section",
            {
              ref: "customer",
              attrs: {
                number: _vm.phaseNumber(3),
                title: "Asiakkaan tiedot",
                mode: _vm.sections.customer.mode,
                "proceed-action-state": _vm.sections.customer.proceedActionState()
              },
              on: {
                modify: function($event) {
                  return _vm.sections.customer.enterModify()
                },
                proceed: function($event) {
                  return _vm.sections.customer.proceed()
                }
              }
            },
            [
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                ? _c("customer-information", {
                    ref: "customerInformation",
                    attrs: {
                      slot: "edit",
                      validationErrors: _vm.validationErrors,
                      "show-authentication": _vm.showAuthentication,
                      "hide-authentication-forced-text":
                        _vm.hideAuthenticationForcedText,
                      offerRequest: _vm.offerRequest
                    },
                    on: {
                      "customer-value-updated": _vm.customerValueUpdated,
                      authenticate: _vm.authenticate
                    },
                    slot: "edit"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.CONSUMER
                ? _c("customer-information-display", {
                    attrs: { slot: "display" },
                    slot: "display"
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
        ? _c(
            "new-contract-section",
            {
              ref: "company",
              attrs: {
                number: _vm.phaseNumber(3),
                title: "Asiakkaan tiedot",
                mode: _vm.sections.company.mode,
                "proceed-action-state": _vm.sections.company.proceedActionState()
              },
              on: {
                modify: function($event) {
                  return _vm.sections.company.enterModify()
                },
                proceed: function($event) {
                  return _vm.sections.company.proceed()
                }
              }
            },
            [
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
                ? _c("company-information", {
                    ref: "companyInformation",
                    attrs: {
                      slot: "edit",
                      validationErrors: _vm.validationErrors,
                      "show-authentication": _vm.showAuthentication
                    },
                    on: {
                      "company-value-updated": _vm.companyValueUpdated,
                      authenticate: _vm.authenticate
                    },
                    slot: "edit"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.contract.CustomerType == _vm.CustomerTypeEnum.COMPANY
                ? _c("company-information-display", {
                    attrs: { slot: "display" },
                    slot: "display"
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "new-contract-section",
        {
          ref: "meteringPoint",
          attrs: {
            number: _vm.phaseNumber(4),
            title: "Osoitetiedot",
            mode: _vm.sections.meteringPoint.mode,
            "proceed-action-state": _vm.ActionState.Hidden
          },
          on: {
            modify: function($event) {
              return _vm.sections.meteringPoint.enterModify()
            }
          }
        },
        [
          _c("metering-point-information", {
            ref: "meteringPointInfo",
            attrs: {
              slot: "edit",
              contract: _vm.contract,
              validationErrors: _vm.validationErrors,
              "has-membership": _vm.hasMembership()
            },
            slot: "edit"
          }),
          _vm._v(" "),
          _c("metering-point-information-display", {
            attrs: { slot: "display" },
            slot: "display"
          })
        ],
        1
      ),
      _vm._v(" "),
      (this.contract.Customer && this.contract.Customer.TrustedSource) ||
      (this.contract.Company && this.contract.Company.TrustedSource)
        ? _c("div", { staticClass: "row mt-2", class: _vm.processBrand }, [
            _c(
              "div",
              { staticClass: "col-md-12 text-center" },
              [
                !_vm.offerRequest
                  ? _c(
                      "b-button",
                      {
                        attrs: { type: "button", variant: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.nextPhase()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Jatka yhteenvetoon")))]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.offerRequest
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "form",
                  {
                    staticClass: "text-center",
                    attrs: {
                      method: "post",
                      action:
                        "/NewContract/Contract/SendOffer?showDetailsPage=true"
                    }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { id: "tooltip-wrapper" } },
                      [
                        _vm.enabledOfferRequestButton()
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-Accept",
                                staticStyle: {
                                  "margin-bottom": "2px !important"
                                },
                                attrs: {
                                  type: "submit",
                                  disabled: !_vm.enabledOfferRequestButton()
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Jätä tarjouspyyntö"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.enabledOfferRequestButton()
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary btn-Accept disabled",
                                staticStyle: {
                                  "margin-bottom": "2px !important"
                                },
                                attrs: { type: "reset" }
                              },
                              [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Jätä tarjouspyyntö"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.enabledOfferRequestButton()
                          ? _c("b-tooltip", {
                              attrs: {
                                target: "tooltip-wrapper",
                                triggers: "click",
                                title:
                                  "Sinun täytyy täyttää kaikki vaaditut kentät ennen kuin voit jättää tarjouspyynnön."
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }